module.exports = __webpack_public_path__ + "images/go_beyond_desktop.webp";